// src/utils/budgetMath.js
// Single source of truth for the Budget tab's "Budget spent %" ring.
//
// BudgetTab renders this number; App.js syncs the SAME number to the widgets, so
// anything a user excludes in Settings is excluded everywhere without the widget
// needing its own copy of the rules. Do not reimplement this anywhere else.

export const computeBudgetSpentPercent = ({
  expenseTransactions = [],
  monthlyCategoryBudgets = {},
  monthlyDebtBudgets = {},
  userDebts = [],
  excludedCategories = [],
  monthlyBudget = 0,
} = {}) => {
  const excluded = excludedCategories || [];
  const excludeDebtPayments = excluded.includes('__DEBT_PAYMENTS__');

  const totalBudgetedForCategories = Object.entries(monthlyCategoryBudgets || {})
    .filter(([cat]) => !excluded.includes(cat) && cat !== 'Savings & Investments' && cat !== 'Withdrawal')
    .reduce((sum, [, b]) => sum + (b || 0), 0);

  const spentExcludingExcluded = (expenseTransactions || [])
    .filter(t => !excluded.includes(t.category) && !t.is_savings && !(excludeDebtPayments && t.is_debt_payment))
    .reduce((sum, t) => sum + t.amount, 0);

  const validDebtIds = new Set((userDebts || []).map(d => d.id));
  const totalDebtBudgets = Object.entries(monthlyDebtBudgets || {})
    .filter(([id]) => validDebtIds.has(id))
    .reduce((sum, [, budget]) => sum + (budget || 0), 0);

  const debtBudgetToInclude = excludeDebtPayments ? 0 : totalDebtBudgets;
  const budgetForSpentCalc = (totalBudgetedForCategories + debtBudgetToInclude) > 0
    ? totalBudgetedForCategories + debtBudgetToInclude
    : monthlyBudget;

  const budgetSpentPercent = budgetForSpentCalc > 0
    ? Math.round((spentExcludingExcluded / budgetForSpentCalc) * 100)
    : 0;

  return { spentExcludingExcluded, budgetForSpentCalc, budgetSpentPercent };
};
